// The schema bellow is set accordingly to a specific action that iOS app expects to receive.
// The object message has no contract required, we can send any data to iOS app.

// So, for example, when the browser finishes to load a webview page, it will call the componentDidMount React lifecycle
// then the action 'didFinishLoad' will be chosen to send a warning to iOSapp as an object message 'finished: true'

export default {
  didFinishLoad: {
    finished: 'boolean'
  },
  editedOrder: {
    orderId: 'number'
  },
  canceledOrder: {
    orderId: 'number'
  },
  didExpireSelfHelp: {
    orderId: 'number'
  },
  openExternalLink: {
    url: 'string'
  },
  createdCreditCard: {
    id: 'number',
    cardType: 'string',
    lastDigits: 'string'
  },
  updateHeader: {
    title: 'string',
    canGoBack: 'boolean'
  },
  openOrder: {
    orderId: 'number'
  },
  displayDroppedOrderDialog: {
    orderId: 'number'
  },
  finishedOrder: {
    orderId: 'number'
  }
};
